/**
 * @fileoverview gRPC-Web generated client stub for acompanha.sales_channels.v1
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v4.25.2
// source: acompanha/sales_channels/v1/sales_channels.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var acompanha_common_v1_common_pb = require('../../../acompanha/common/v1/common_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.acompanha = {};
proto.acompanha.sales_channels = {};
proto.acompanha.sales_channels.v1 = require('./sales_channels_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.sales_channels.v1.SalesChannelsServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.acompanha.sales_channels.v1.SalesChannelsServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.sales_channels.v1.ListSalesChannelsRequest,
 *   !proto.acompanha.sales_channels.v1.ListSalesChannelsResponse>}
 */
const methodDescriptor_SalesChannelsService_ListSalesChannels = new grpc.web.MethodDescriptor(
  '/acompanha.sales_channels.v1.SalesChannelsService/ListSalesChannels',
  grpc.web.MethodType.UNARY,
  proto.acompanha.sales_channels.v1.ListSalesChannelsRequest,
  proto.acompanha.sales_channels.v1.ListSalesChannelsResponse,
  /**
   * @param {!proto.acompanha.sales_channels.v1.ListSalesChannelsRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.sales_channels.v1.ListSalesChannelsResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.sales_channels.v1.ListSalesChannelsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.sales_channels.v1.ListSalesChannelsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.sales_channels.v1.ListSalesChannelsResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.sales_channels.v1.SalesChannelsServiceClient.prototype.listSalesChannels =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.sales_channels.v1.SalesChannelsService/ListSalesChannels',
      request,
      metadata || {},
      methodDescriptor_SalesChannelsService_ListSalesChannels,
      callback);
};


/**
 * @param {!proto.acompanha.sales_channels.v1.ListSalesChannelsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.sales_channels.v1.ListSalesChannelsResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.sales_channels.v1.SalesChannelsServicePromiseClient.prototype.listSalesChannels =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.sales_channels.v1.SalesChannelsService/ListSalesChannels',
      request,
      metadata || {},
      methodDescriptor_SalesChannelsService_ListSalesChannels);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.sales_channels.v1.CreateSalesChannelRequest,
 *   !proto.acompanha.sales_channels.v1.CreateSalesChannelResponse>}
 */
const methodDescriptor_SalesChannelsService_CreateSalesChannel = new grpc.web.MethodDescriptor(
  '/acompanha.sales_channels.v1.SalesChannelsService/CreateSalesChannel',
  grpc.web.MethodType.UNARY,
  proto.acompanha.sales_channels.v1.CreateSalesChannelRequest,
  proto.acompanha.sales_channels.v1.CreateSalesChannelResponse,
  /**
   * @param {!proto.acompanha.sales_channels.v1.CreateSalesChannelRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.sales_channels.v1.CreateSalesChannelResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.sales_channels.v1.CreateSalesChannelRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.sales_channels.v1.CreateSalesChannelResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.sales_channels.v1.CreateSalesChannelResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.sales_channels.v1.SalesChannelsServiceClient.prototype.createSalesChannel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.sales_channels.v1.SalesChannelsService/CreateSalesChannel',
      request,
      metadata || {},
      methodDescriptor_SalesChannelsService_CreateSalesChannel,
      callback);
};


/**
 * @param {!proto.acompanha.sales_channels.v1.CreateSalesChannelRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.sales_channels.v1.CreateSalesChannelResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.sales_channels.v1.SalesChannelsServicePromiseClient.prototype.createSalesChannel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.sales_channels.v1.SalesChannelsService/CreateSalesChannel',
      request,
      metadata || {},
      methodDescriptor_SalesChannelsService_CreateSalesChannel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest,
 *   !proto.acompanha.sales_channels.v1.UpdateSalesChannelResponse>}
 */
const methodDescriptor_SalesChannelsService_UpdateSalesChannel = new grpc.web.MethodDescriptor(
  '/acompanha.sales_channels.v1.SalesChannelsService/UpdateSalesChannel',
  grpc.web.MethodType.UNARY,
  proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest,
  proto.acompanha.sales_channels.v1.UpdateSalesChannelResponse,
  /**
   * @param {!proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.acompanha.sales_channels.v1.UpdateSalesChannelResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.sales_channels.v1.UpdateSalesChannelResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.sales_channels.v1.UpdateSalesChannelResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.sales_channels.v1.SalesChannelsServiceClient.prototype.updateSalesChannel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.sales_channels.v1.SalesChannelsService/UpdateSalesChannel',
      request,
      metadata || {},
      methodDescriptor_SalesChannelsService_UpdateSalesChannel,
      callback);
};


/**
 * @param {!proto.acompanha.sales_channels.v1.UpdateSalesChannelRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.sales_channels.v1.UpdateSalesChannelResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.sales_channels.v1.SalesChannelsServicePromiseClient.prototype.updateSalesChannel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.sales_channels.v1.SalesChannelsService/UpdateSalesChannel',
      request,
      metadata || {},
      methodDescriptor_SalesChannelsService_UpdateSalesChannel);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.acompanha.sales_channels.v1.DeleteSalesChannelRequest,
 *   !proto.acompanha.common.v1.DeleteResponse>}
 */
const methodDescriptor_SalesChannelsService_DeleteSalesChannel = new grpc.web.MethodDescriptor(
  '/acompanha.sales_channels.v1.SalesChannelsService/DeleteSalesChannel',
  grpc.web.MethodType.UNARY,
  proto.acompanha.sales_channels.v1.DeleteSalesChannelRequest,
  acompanha_common_v1_common_pb.DeleteResponse,
  /**
   * @param {!proto.acompanha.sales_channels.v1.DeleteSalesChannelRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  acompanha_common_v1_common_pb.DeleteResponse.deserializeBinary
);


/**
 * @param {!proto.acompanha.sales_channels.v1.DeleteSalesChannelRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.acompanha.common.v1.DeleteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.acompanha.common.v1.DeleteResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.acompanha.sales_channels.v1.SalesChannelsServiceClient.prototype.deleteSalesChannel =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/acompanha.sales_channels.v1.SalesChannelsService/DeleteSalesChannel',
      request,
      metadata || {},
      methodDescriptor_SalesChannelsService_DeleteSalesChannel,
      callback);
};


/**
 * @param {!proto.acompanha.sales_channels.v1.DeleteSalesChannelRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.acompanha.common.v1.DeleteResponse>}
 *     Promise that resolves to the response
 */
proto.acompanha.sales_channels.v1.SalesChannelsServicePromiseClient.prototype.deleteSalesChannel =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/acompanha.sales_channels.v1.SalesChannelsService/DeleteSalesChannel',
      request,
      metadata || {},
      methodDescriptor_SalesChannelsService_DeleteSalesChannel);
};


module.exports = proto.acompanha.sales_channels.v1;

